<div [ngClass]="['spinner', 'spinner--' + size, 'spinner--' + color]">
  <div class="spinner__dot spinner__dot--1"></div>
  <div class="spinner__dot spinner__dot--2"></div>
  <div class="spinner__dot spinner__dot--3"></div>
  <div class="spinner__dot spinner__dot--4"></div>
  <div class="spinner__dot spinner__dot--5"></div>
</div>
